import { HStack, VStack } from '@bpba/ui-components';
import styled from 'styled-components';
import { TypographyProps, typography, MarginProps, margin } from 'styled-system';

import { CARROUSEL_RADIUS } from '../../constants/data';
import { useCountDown } from './useCountDown';

const DAY_LABEL = 'DÍA';
const HOUR_LABEL = 'HORA';
const MINUTE_LABEL = 'MINUTO';
const DAYS_LABEL = `${DAY_LABEL}S`;
const HOURS_LABEL = `${HOUR_LABEL}S`;
const MINUTES_LABEL = `${MINUTE_LABEL}S`;

type Props = {
  fecha?: string;
  includeMargin?: boolean;
};

export const CuentaRegresiva = ({ fecha, includeMargin }: Props) => {
  const [validDate, days, hours, minutes] = useCountDown(fecha);
  const dayTitle = days === 1 ? DAY_LABEL : DAYS_LABEL;
  const hourTitle = hours === 1 ? HOUR_LABEL : HOURS_LABEL;
  const minuteTitle = minutes === 1 ? MINUTE_LABEL : MINUTES_LABEL;

  let accessibilityText = '';
  if (validDate) {
    if (days !== 0 || hours !== 0 || minutes !== 0)
      accessibilityText = `${getAccessibilityText(days, dayTitle)} ${getAccessibilityText(hours, hourTitle)} ${getAccessibilityText(minutes, minuteTitle)}`;
    else accessibilityText = `0 ${minuteTitle}`;
  }

  if (!validDate) return <></>;

  return (
    <HStack justifyContent="center" marginTop={includeMargin ? ['5px', '10px'] : []} aria-label={accessibilityText} role="link" tabIndex={0}>
      <ClockValue value={days} title={dayTitle} />
      <ClockValue value={hours} title={hourTitle} />
      <ClockValue value={minutes} title={minuteTitle} last={true} />
    </HStack>
  );
};
CuentaRegresiva.defaultProps = {
  includeMargin: true,
};

function getAccessibilityText(value: number, label: string) {
  return value != 0 ? `${value} ${label}` : '';
}

type ClockValueProps = {
  value: number;
  title: string;
  last?: boolean;
};

const ClockValue = ({ value, title, last }: ClockValueProps) => {
  return (
    <VStack backgroundColor="white" color="secondary.1" width={58} height={66} marginRight={last ? '0px' : '14px'} justifyContent="center" borderRadius={CARROUSEL_RADIUS} aria-hidden="true">
      <Text fontSize={['40px']} lineHeight={['40px']} marginY={['0px']}>
        {addPad(value)}
      </Text>
      <Text fontSize={['11px']} marginY={['0px']}>
        {title}
      </Text>
    </VStack>
  );
};

ClockValue.defaultProps = {
  last: false,
};

/*Representa el número ingresado en dos dígitos.*/
function addPad(value: number): string {
  if (value > 9) return value.toString();
  return '0' + value.toString();
}

const Text = styled.div<TypographyProps & MarginProps>(typography, margin);
